import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConstantUrination = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 35,
	height: 29,
	viewBox: "0 0 35 29",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			d: "M1 10L13.5556 13.1389C15.7837 13.6959 17.7522 15.003 19.1302 16.8403L27.5 28",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeDasharray: "2 5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			d: "M4 6L16.5556 9.1389C18.7837 9.69593 20.7522 11.003 22.1302 12.8403L30.5 24",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeDasharray: "2 5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			d: "M7 1L19.5556 4.1389C21.7837 4.69593 23.7522 6.00296 25.1302 7.84033L33.5 19",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeDasharray: "2 5"
		})
	]
});
export default SvgConstantUrination;
